import React, {Component} from "react";
import {connect} from "react-redux";

import * as componentTypes from "../../constants/componentTypes";
import * as navigationActions from "../../actions/navigationActions";
import * as settingsActions from "../../actions/settingsActions";
import * as rccActions from "../../actions/rccActions";

import StirModalComponent from "../../components/global/modal/StirModal";

class StirModal extends Component {
    closeModal = () => {
        this.props.dispatchCloseModalAction();
    };

    stirCanisters = (canisters, stirringTime, stirringSpeed) => {
        this.props.dispatchStirCanistersAction(canisters, stirringTime, stirringSpeed);
    };

    render() {
        return (
            <StirModalComponent
                modalId={this.props.id}
                tabId={this.props.tabId}
                canisterList={this.props.canisterList}
                colorantList={this.props.colorantList}
                closeModal={this.closeModal}
                stirCanisters={this.stirCanisters}
                setStirringTime={this.props.dispatchSetStirringTimeAction}
                setStirringSpeed={this.props.dispatchSetStirringSpeedAction}
                stirringSpeed={this.props.stirringSpeed}
                stirringTime={this.props.stirringTime}
                loggedUser={this.props.loggedUser}
                id={this.props.id}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        canisterList: store.rcc.canisterList,
        colorantList: store.global.colorantList,
        stirringSpeed: store.settings.stirringSpeed,
        stirringTime: store.settings.stirringTime,
        loggedUser: store.login.loggedUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.STIR_CANISTERS_MODAL));
        },
        dispatchStirCanistersAction: (canisters, stirringTime, stirringSpeed) => {
            dispatch(rccActions.stirCanisters(canisters, stirringTime, stirringSpeed));
        },
        dispatchSetStirringTimeAction: (stirringTime) => {
            dispatch(settingsActions.setStirringTime(stirringTime));
        },
        dispatchSetStirringSpeedAction: (stirringSpeed) => {
            dispatch(settingsActions.setStirringSpeed(stirringSpeed));
        }
    };
};

export default StirModal = connect(mapStoreToProps, mapDispatchToProps)(StirModal);
